"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuidelineType = void 0;
var GuidelineType;
(function (GuidelineType) {
    GuidelineType["INCLUSION"] = "inclusion";
    GuidelineType["EXCLUSION"] = "exclusion";
})(GuidelineType || (exports.GuidelineType = GuidelineType = {}));
